import {
  initialEndDate,
  initialStartDate,
} from '@user/components/Scheduling/utils'
import type { InitArg, State } from './typings'

export function init(params: InitArg): State {
  const { entityId, entityType, salesFunnelId } = params

  return {
    entityId,
    entityType,
    salesFunnelId,

    stack: [],

    page: 0,
    loading: false,

    branchId: -1,
    externalSvcLocId: '',

    commitProcessing: false,

    canClose: false,
    closeOnCommit: false,
    requireACWOppsSchedulingService: false,

    bestFitInput: {
      entityType,
      appointmentId: null,

      startDate: initialStartDate,
      endDate: initialEndDate,

      startTime: undefined,
      endTime: undefined,

      duration: undefined,

      techRegionId: '',
      techId: '[]',

      serviceIds: [],
    },
  }
}
